var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.733 6.48144H17.2278C17.8789 6.48144 18.4068 5.95791 18.4068 5.31209C18.4068 4.66631 17.8789 4.14277 17.2278 4.14277H9.71671L7.14636 5.10434V13.1404H8.44163L11.8074 17.0026L12.1005 18.6041C12.1425 18.8333 12.3437 19 12.5787 19H13.154C13.9886 19 14.6652 18.3289 14.6652 17.5011C14.6652 16.877 14.5421 16.259 14.3029 15.6818L13.4372 13.4975H13.6588M15.6986 11.1588H18.318C18.9691 11.1588 19.497 11.6823 19.497 12.3281C19.497 12.9739 18.9691 13.4974 18.318 13.4974H13.6588M16.3263 11.1588H18.821C19.4722 11.1588 20 10.6352 20 9.98946C20 9.34368 19.4722 8.82011 18.821 8.82011H16.3263M15.6189 8.82011H18.1137C18.7649 8.82011 19.2927 8.29658 19.2927 7.65076C19.2927 7.00498 18.7649 6.48145 18.1137 6.48145H15.6189M7.14636 4H4V14.0833H7.14636V4Z",
    stroke: "#CF2F92",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbsDown.830cdaae40444b7938bb392c157b0b47.svg";
export { ForwardRef as ReactComponent };